<template>
	<section>
        <template v-if="field.field == 'dropdown' && field.source == 'template'">   
            <b-select placeholder="Select Template" v-model="model" expanded @focus="$emit('update:isEditing', data.row.id)">
                <option :value="null" key="template">Unassined</option>
                <option v-for="(option, key) in options" :value="option.id" :key="key">
                    {{ option.name }}
                </option>
            </b-select>
        </template>
        <template v-else-if="field.field == 'dropdown' && field.source == 'code'">   
            <b-select placeholder="Select Template" v-model="model" expanded @focus="$emit('update:isEditing', data.row.id)">
                <option :value="null" key="code-chain">Unassined</option>
                <option v-for="(option, key) in options" :key="key">
                    {{ option.type }}
                </option>
            </b-select>
        </template>
		<template v-else>
            <b-input v-model="model" @focus="$emit('update:isEditing', data.row.id)" @blur="$emit('hideSaveButton')"></b-input>
		</template>
	</section>
</template>
<script>
import { TemplateService } from "@/services/template.service";
import { CodeService } from "@/services/code.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer.js";
export default {
	props: [ 'field', 'data', 'isEditing' ],
    data: () => ({
    	model: null, 
    	options: []
    }),
    computed: {
    	value() {
            // this.model = this.data.row.value
    		return this.data.row.value;
    	}
    },
    watch: {
    	value(value) {
    		this.model = value;
    	}, 
    	model(value) {
    		if (value) {
		    	switch(this.field) {
		            case 'dropdown': 
		            	this.$emit('update:isEditing', this.data.row.id)
		            break;
		        }
    		}
    	}
    },
    methods: {
    	getOptions(template) {
            if (template == 'template') {
        		TemplateService.all().then(response => {
        			this.options = JsonDenormalizer.denormalize(response).sort((a, b) => {
    					var x = a.name.toLowerCase(), y = b.name.toLowerCase();
    					return x < y ? -1 : x > y ? 1 : 0;
        			});
        		});
            } else if (template == 'code') {
                // this.options = [
                //     'orderType', 'activityType', 'problem_codes', 'failure_codes'
                // ]
                CodeService.codeByType().then(response => {
                    this.options = JsonDenormalizer.denormalize(response);
                })
            }
    	}
    },
    mounted() {
        if (this.field.field == 'dropdown') {
            this.getOptions(this.field.source);
        }
        this.model = this.value
    }

};
</script>



// WEBPACK FOOTER //
// src/components/pages/Attributes/_partials/templateComponent.vue